<script setup>
import { useStore } from 'vuex'
import router from '@/router'
import { ImClient } from '@/IM/imClient'
import { setMessageKey } from '@/utils/handleSomeData'
import ring from '@/assets/ring.mp3'
import { getUserInfo } from '@/api/custom'
import { onMounted, onUnmounted } from 'vue'
import { imSocket } from '@/IM/wsClient'
import { goToMsgBody } from '@/utils/handleSomeData/goMsgAdapter'
const store = useStore()
onMounted(() => {
    // 和虞都服务器做个心跳包，定时请求接口，避免token超时
    clearInterval()
    setInterval(() => {
        if (router.currentRoute.value.path != '/login') {
            getUserInfo().then((res) => {
                if (res.code == 200 && res.data) {
                    window.localStorage.setItem(
                        'customUserInfo',
                        JSON.stringify(res.data)
                    )
                }
            })
        }
    }, 5 * 60 * 1000)
})
onUnmounted(() => {
    clearInterval()
})
//fetch 登陆用户的初始数据
const fetchLoginUsersInitData = () => {
    // 去旧IM：好友/黑名单/用户资料读依赖旧IM，暂去掉；群列表后续走 Go。先初始化会话列表。
    store.commit('INIT_CONVERSATION_STATE')
    const userId = ImClient.user
    store.commit('CLEAR_INFORM_LIST_INFO_NEW')
    store.dispatch('getSessionList', {
        userId: userId,
        msgType: 0,
        pageSize: 200,
        pageNum: 1
    })
    // 启动时初始化"我加入的群"，否则搜索搜不到未加载进会话列表的群（如久未活跃的旧群）
    store.dispatch('fetchGroupList', { pageNum: 1, pageSize: 600 })
    localStorage.setItem('chatTypeInfo', 1)
}

/* 重新登陆 */
//读取本地ZHWIM_loginUser
let ZHWIM_loginUser = window.localStorage.getItem('ZHWIM_loginUser')

if (ZHWIM_loginUser) {
    ZHWIM_loginUser = JSON.parse(ZHWIM_loginUser)
}
const loginUserFromStorage = ZHWIM_loginUser || {}
// 去旧IM：不再 open 旧IM，改为启动自研 WS 收消息 + 初始化会话数据
const startGoIM = () => {
    let token = window.localStorage.getItem('customToken')
    if ((!token || token === 'undefined') && loginUserFromStorage.accessToken) {
        token = loginUserFromStorage.accessToken
        window.localStorage.setItem('customToken', JSON.stringify(token))
    }
    if (!token || token === 'undefined') return
    // 去旧IM：原 loginState 由旧IM onConnected 置 true；现直接置 true，否则 messageData 永远返回空、聊天框不显示
    store.commit('CHANGE_LOGIN_STATUS', true)
    // 去旧IM：自己头像/昵称从登录态 customUserInfo 填入 loginUserInfo（原由旧IM getMyUserInfo 设）
    try {
        const me = JSON.parse(window.localStorage.getItem('customUserInfo') || '{}')
        store.commit('SET_LOGIN_USER_INFO', {
            ...me,
            avatarurl: me.avatar,
            nickname: me.nickName,
            hxId: me.hxusername
        })
    } catch (e) {
        /* ignore */
    }
    imSocket.connect()
    imSocket.on('msg.send', (p) => {
        const body = goToMsgBody(p)
        if (!body) return
        store.commit('UPDATE_NEW_MESSAGE_SESSION_KEY', setMessageKey(body))
        store.dispatch('createNewMessage', body)
    })
    imSocket.on('msg.recall', (p) => {
        // 撤回 payload 只有 messageId/sessionId，从 sessionId 反推会话 key（去掉自己 hx）
        const myHx = ImClient.user
        const sid = (p && p.sessionId) || ''
        let key = sid
        if (myHx && sid.startsWith(myHx)) key = sid.slice(myHx.length)
        else if (myHx && sid.endsWith(myHx)) key = sid.slice(0, sid.length - myHx.length)
        store.commit('CHANGE_MESSAGE_BODAY', { type: 'recall', key, mid: p.messageId })
    })
    imSocket.on('session.update', (p = {}) => {
        const groupId = p.groupId || p.sessionId
        if (p.kind === 'group.deleted' && groupId) {
            store.commit('DELETE_ONE_CONVERSATION', groupId)
            store.commit('UPDATE_GROUP_LIST', {
                type: 'deleteFromList',
                groupId
            })
            if (router.currentRoute.value?.query?.id === groupId) {
                router.push('/chat/conversation')
            }
            return
        }
        const scope = store.state.Conversation.currentConversationScope || { type: 'all' }
        const params = {
            userId: ImClient.user,
            msgType: 0,
            pageSize: 200,
            pageNum: 1
        }
        if (scope.type === 'single') params.msgType = 1
        else if (scope.type === 'group') params.msgType = 2
        else if (scope.type === 'today') {
            params.msgType = 2
            params.today = 1
        } else if (scope.type === 'category') {
            params.msgType = 2
            params.groupCategory = scope.groupCategory
        }
        store.dispatch('getSessionList', params)
        if (groupId) {
            store.dispatch('fetchGoupsMember', groupId)
            store.dispatch('getGroupPersons', {
                groupId,
                fromHxId: ImClient.user
            })
        }
    })
    fetchLoginUsersInitData()
}
if (window.localStorage.getItem('customToken') || loginUserFromStorage.accessToken) {
    startGoIM()
}
</script>
<template>
    <router-view v-slot="{ Component }">
        <transition
            name="slide-fade"
            mode="out-in"
            :duration="{ enter: 500, leave: 300 }"
        >
            <component :is="Component" />
        </transition>
    </router-view>
    <!-- 铃声标签 -->
    <audio id="ring" :src="ring" controls hidden></audio>
</template>

<style type="scss">
@import './styles/reset/reset.css';
@import './styles/iconfont/iconfont.css';

/* .slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  opacity: 0.3;
}

.slide-fade-enter-to,
.slide-fade-leave-from {
  opacity: 1;
} */
.el-dialog__header {
    background: #f2f2f2;
    margin: 0 !important;
}
.el-dialog__body {
    padding: 10px !important;
    /* background-color: #f9f9f9; */
}
</style>
